(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discount-wheel"]) return;
  try {
    
  (() => {
    const wheel = document.querySelector('[data-discount-wheel]');
    if (!wheel || wheel.dataset.ready === 'true') return;
    wheel.dataset.ready = 'true';

    const storageKey = 'wr_discount_wheel_seen';
    const delay = Math.max(Number(wheel.dataset.delay || 12000), 12000);
    const cooldown = Number(wheel.dataset.cooldown || 30) * 86400000;
    const pageType = wheel.dataset.pageType;
    const inEditor = Boolean(window.Shopify && window.Shopify.designMode);
    let seenAt = 0;

    try { seenAt = Number(localStorage.getItem(storageKey) || 0); } catch (error) { seenAt = 0; }
    const eligible = inEditor || (pageType !== 'cart' && (!seenAt || Date.now() - seenAt > cooldown));

    const remember = () => {
      if (inEditor) return;
      try { localStorage.setItem(storageKey, String(Date.now())); } catch (error) {}
      const expires = new Date(Date.now() + cooldown).toUTCString();
      document.cookie = `${storageKey}=1; expires=${expires}; path=/; SameSite=Lax`;
    };

    let delayPassed = false;
    let opened = false;
    let checks = 0;

    const privacyBannerVisible = () => {
      const banner = document.querySelector('#shopify-pc__banner');
      return Boolean(banner && banner.getClientRects().length);
    };

    const hasEnoughProductEngagement = () => {
      if (pageType !== 'product') return true;
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      return scrollable > 0 && window.scrollY / scrollable >= .2;
    };

    const openWheel = () => {
      if (!eligible || !delayPassed || opened || wheel.open || privacyBannerVisible() || !hasEnoughProductEngagement()) return;
      wheel.showModal();
      opened = true;
    };

    if (eligible) {
      window.setTimeout(() => {
        delayPassed = true;
        openWheel();
      }, delay);
      window.addEventListener('scroll', openWheel, { passive: true });
      const consentCheck = window.setInterval(() => {
        checks += 1;
        openWheel();
        if (opened || checks >= 120) window.clearInterval(consentCheck);
      }, 1000);
    }

    wheel.querySelector('[data-wheel-close]')?.addEventListener('click', () => {
      remember();
      wheel.close();
    });

    wheel.addEventListener('click', (event) => {
      if (event.target === wheel) {
        remember();
        wheel.close();
      }
    });

    wheel.addEventListener('cancel', remember);

    const form = wheel.querySelector('.wr-wheel__form');
    const disc = wheel.querySelector('[data-wheel-disc]');
    const spinButton = wheel.querySelector('[data-wheel-spin]');
    const result = wheel.querySelector('[data-wheel-result]');
    const won = wheel.querySelector('[data-wheel-won]');
    const codeButton = wheel.querySelector('[data-wheel-code]');
    const prizes = [
      { label: '5% OFF', code: wheel.dataset.codeFive },
      { label: '10% OFF', code: wheel.dataset.codeTen },
      { label: '5% OFF', code: wheel.dataset.codeFive },
      { label: 'FREE SHIPPING', code: wheel.dataset.codeShipping },
      { label: '5% OFF', code: wheel.dataset.codeFive },
      { label: '10% OFF', code: wheel.dataset.codeTen },
      { label: '15% OFF', code: wheel.dataset.codeFifteen },
      { label: '5% OFF', code: wheel.dataset.codeFive }
    ];

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity() || spinButton.disabled) return;
      spinButton.disabled = true;

      const index = Math.floor(Math.random() * prizes.length);
      const turns = 6;
      const stopAngle = 360 - index * 45;
      disc.style.transform = `rotate(${turns * 360 + stopAngle}deg)`;

      try {
        await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } });
      } catch (error) {}

      window.setTimeout(() => {
        const prize = prizes[index];
        form.hidden = true;
        won.textContent = `You won ${prize.label}`;
        codeButton.textContent = `${prize.code} · ${wheel.dataset.copyLabel}`;
        codeButton.dataset.code = prize.code;
        result.hidden = false;
        remember();
        codeButton.focus();
      }, 4900);
    });

    codeButton?.addEventListener('click', async () => {
      const code = codeButton.dataset.code;
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
        codeButton.textContent = `${code} · ${wheel.dataset.copiedLabel}`;
      } catch (error) {
        const range = document.createRange();
        range.selectNodeContents(codeButton);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
    });

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.contains(wheel) && !wheel.open) wheel.showModal();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
